/**
 * 个人空间 路由列表
 */

export const personalSpaceRoutes = [
  {
    path: "/personal-space",
    name: "LayoutPersonalSpace",
    component: () => import("@/layout/personal-space/index.vue"),
    meta: {
      title: "个人空间",
    },
    children: [
      {
        path: "",
        name: "LayoutPersonalSpaceDefault",
        redirect: "/personal-space/workbenches",
      },
      {
        path: "messages",
        name: "PagePersonalSpaceMessages",
        redirect: "/personal-space/messages/index",
        component: () => import("@/layout/index/route.vue"),
        meta: {
          title: "待办消息",
        },
        children: [
          {
            path: "index",
            name: "PagePersonalSpaceMessagesIndex",
            component: () =>
              import("@/views/personal-space/messages/index.vue"),
          },
        ],
      },
      {
        path: "notice",
        name: "PagePersonalSpaceNotice",
        redirect: "/personal-space/notice/index",
        component: () => import("@/layout/index/route.vue"),
        meta: {
          title: "我的消息",
        },
        children: [
          {
            path: "index", // 通知消息
            name: "PagePersonalSpaceNoticeIndex",
            component: () => import("@/views/personal-space/notice/index.vue"),
          },
          {
            path: "detail",
            name: "PagePersonalSpaceNoticeDetail",
            component: () => import("@/views/personal-space/notice/detail.vue"),
          },
        ],
      },
      {
        path: "workbenches",
        name: "PagePersonalSpaceWorkbenches",
        redirect: "/personal-space/workbenches/index",
        component: () => import("@/layout/index/route.vue"),
        meta: {
          title: "工作台",
        },
        children: [
          {
            path: "index",
            name: "PagePersonalSpaceWorkbenchesDefault",
            component: () =>
              import("@/views/personal-space/workbenches/index.vue"),
          },
          {
            path: "rudang",
            name: "PagePersonalSpaceWorkbenchesRuDang",
            component: () =>
              import("@/views/personal-space/workbenches/rudang/index.vue"),
            meta: {
              title: "入党申请",
            },
          },
          {
            path: "rudang-list",
            name: "PagePersonalSpaceWorkbenchesRuDangRecord",
            component: () =>
              import("@/views/personal-space/workbenches/rudang/record.vue"),
            meta: {
              title: "入党申请",
            },
          },
          {
            path: "rudang-apply",
            name: "PagePersonalSpaceWorkbenchesRuDangApply",
            component: () =>
              import("@/views/personal-space/workbenches/rudang/apply.vue"),
            meta: {
              title: "入党申请",
            },
          },
          {
            path: "training-dues",
            name: "PagePersonalSpaceWorkbenchesTrainingDues",
            component: () => import("@/views/training-dues/home/index.vue"),
            meta: {
              title: "我的党费",
            },
          },
          {
            path: "activity",
            name: "PagePersonalSpaceWorkbenchesActivity",
            component: () =>
              import("@/views/personal-space/workbenches/activity/index.vue"),
            meta: {
              title: "党组织活动",
            },
          },
        ],
      },
      {
        path: "my",
        name: "PagePersonalSpaceMy",
        redirect: "/personal-space/my/index",
        component: () => import("@/layout/index/route.vue"),
        meta: {
          title: "我的",
        },
        children: [
          {
            path: "index",
            name: "PagePersonalSpaceMyIndex",
            component: () => import("@/views/personal-space/my/index.vue"),
          },
          {
            path: "modify-pwd",
            name: "PagePersonalSpaceMyModifyPwd",
            component: () =>
              import("@/views/personal-space/my/modify-pwd/index.vue"),
            meta: {
              title: "修改密码",
            },
          },
          {
            path: "modify-info",
            name: "PagePersonalSpaceMyModifyInfo",
            component: () =>
              import("@/views/personal-space/my/modify-info/index.vue"),
            meta: {
              title: "修改个人信息",
            },
          },
        ],
      },
    ],
  },
];
